// extracted by mini-css-extract-plugin
export default {"wrapper":"summary_wrapper__4wtuq","summary":"summary_summary__74LD7"};